module.exports = __webpack_public_path__ + "img/gift2.4bbc26e4.png";